import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axiosConfig';

// Acción asíncrona para obtener los tickets del usuario
export const fetchUserTickets = createAsyncThunk(
    'user/fetchUserTickets',
    async ( { slug, userId }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/${slug}/api/tickets/user/${userId}`, {
                validateStatus: s => (s >= 200 && s < 300) || s === 304,
                params: { t: Date.now() },
              });
              //await axios.get(`/${slug}/api/tickets/user/${userId}`);  //agregamos slug
              
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data || error.message);
        }
    }
);

const userSlice = createSlice({
    name: 'user',
    initialState: {
        tickets: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserTickets.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserTickets.fulfilled, (state, action) => {
                state.tickets = action.payload;
                state.loading = false;
            })
            .addCase(fetchUserTickets.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default userSlice.reducer;
